import { render } from "./GPXUploadBox.vue?vue&type=template&id=d64f092e"
import script from "./GPXUploadBox.vue?vue&type=script&lang=js"
export * from "./GPXUploadBox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d64f092e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d64f092e', script)) {
    api.reload('d64f092e', script)
  }
  
  module.hot.accept("./GPXUploadBox.vue?vue&type=template&id=d64f092e", () => {
    api.rerender('d64f092e', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CoordinateData/GPXUploadBox.vue"

export default script